import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from '@posthog/react';

// Map routes to feature names for better analytics
const featureMap = {
  '/newsletterapp': 'Newsletter App',
  '/slideapp': 'Slide App',
  '/calendarapp': 'Calendar App',
  '/designs': 'Community/Designs',
  '/quickprnts': 'Quick Prints',
  '/profile': 'User Profile',
  '/': 'Landing Page',
  '/forgotpassword': 'Forgot Password',
  '/confirmemail': 'Confirm Email',
  '/resetpassword': 'Reset Password',
};

const PageViewTracker = () => {
  const location = useLocation();
  const posthogHook = usePostHog();

  useEffect(() => {
    if (posthogHook && (posthogHook.__loaded || typeof posthogHook.capture === 'function')) {
      // Track pageview
      posthogHook.capture('$pageview', {
        path: location.pathname,
        feature: featureMap[location.pathname] || 'Unknown',
      });

      // Track feature usage for main features
      const mainFeatures = ['/newsletterapp', '/slideapp', '/calendarapp', '/designs', '/quickprnts'];
      if (mainFeatures.includes(location.pathname)) {
        posthogHook.capture('feature_accessed', {
          feature_name: featureMap[location.pathname],
          feature_path: location.pathname,
        });
      }
    } else if (process.env.NODE_ENV === 'development') {
      console.warn('⚠️ PostHog not available via hook');
    }
  }, [location, posthogHook]);

  return null; // This component doesn't render anything
};

export default PageViewTracker;

